export const dateFormator = (date) => {
  // Original date string
  let dateStr = date;

  // Parse the date string into a Date object
  let dateObj = new Date(dateStr);

  // Extract the year, month, and day
  let year = dateObj.getFullYear();
  let month = (dateObj.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
  let day = dateObj.getDate().toString().padStart(2, '0');

  // Format as yyyy-MM-dd
  let formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
};

// Derives the business subdomain from the current hostname, e.g.
// "nightandday.dev.seamlessslot.co.uk" -> "nightandday".
// Falls back to 'nightandday' when the hostname has no subdomain part
// (e.g. localhost during local development).
export const getSubdomain = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  if (parts.length > 2) {
    return parts[0];
  }
  return 'nightandday';
};

// Prefixes that must survive a booking-flow "reset" (localStorage.clear()).
// The public booking pages (Appointment/PatientInfo/CardPayment/ChooseLocation)
// and the location-switcher modal all call this instead of the raw
// localStorage.clear() to reset booking-session keys (selectedService,
// selectedDate, ...) - but this app's admin panel shares the same origin's
// localStorage, so a raw .clear() while testing a flow (same browser, admin
// panel open in another tab) was also wiping an admin's in-progress
// flow-builder-draft:<locationId> draft (see pages/FlowBuilder/store/
// flowBuilderStore.js). Add other prefixes here if something else needs to
// survive a booking reset too.
const STORAGE_PREFIXES_TO_PRESERVE = ['flow-builder-draft:'];

// Drop-in replacement for `localStorage.clear()` in the booking flow - clears
// everything EXCEPT keys under STORAGE_PREFIXES_TO_PRESERVE.
export const clearBookingLocalStorage = () => {
  const keysToRemove = [];
  for (let i = 0; i < window.localStorage.length; i++) {
    const key = window.localStorage.key(i);
    if (key && !STORAGE_PREFIXES_TO_PRESERVE.some((prefix) => key.startsWith(prefix))) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach((key) => window.localStorage.removeItem(key));
};
